import {
  PredefinedValuesSchemaProperty,
  EntitySchemaProperty,
} from "src/entities/queries";

export const isPredefinedValuesProperty = (
  property: EntitySchemaProperty,
): property is PredefinedValuesSchemaProperty => {
  return property._type === "enum" || property._type === "tags";
};

export const MASKING_STRATEGIES = [
  {
    key: "full",
    title: "Full masking",
    description:
      "Replace the entire value with a fixed placeholder (e.g., *****). Nothing from the original value is preserved in the output.",
  },
  {
    key: "partial",
    title: "Partial masking",
    description:
      "Show part of the original value (e.g., last 4 digits), while masking the rest with a character.",
  },
  {
    key: "hash",
    title: "Hash masking",
    description:
      "Transforms the entire value into a one-way cryptographic hash (e.g., SHA256). Irreversible and consistent for the same input.",
  },
];

export const FULL_MASKS = ["****", "####", "MASKED", "REDACTED", "custom"];
export const FULL_MASK_LABELS: Record<string, string> = {
  "****": "****",
  "####": "####",
  MASKED: "MASKED",
  REDACTED: "REDACTED",
  custom: "Define custom mask",
};
export const HASH_ALGOS = ["sha256", "sha512"];
